import { toastError } from '@components/Toast';

import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

import { printApiError } from '@utils/Util';

import { BASE_URL } from '@/constants/constant';

export const updateCollectionById = async (postData) => {
	try {
		const { data } = await ApiClient.PUT('updateCollection', postData);
		return data;
	} catch (error) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const removeProductsFromCollection = async (postData) => {
	try {
		const { data } = await ApiClient.POST('removeProductFromCollection', postData);
		return data;
	} catch (error) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchBrandWiseBuyers = async (params) => {
	try {
		const { data } = await ApiClient.GET('getProjectUserSuggestions', params);
		return data;
	} catch (error) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchCollectionMembers = async (collectionId) => {
	try {
		const { data } = await ApiClient.GET('collectionAction', `${collectionId}/members`);
		return data;
	} catch (error) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const removeCollectionMembers = async (postData) => {
	try {
		const { data } = await ApiClient.POST('removeMemberFromCollection', postData);
		return data;
	} catch (error) {
		if (error?.response?.data?.message) {
			toastError(error.response.data.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const shareCollection = async (postData) => {
	try {
		const { data } = await ApiClient.POST('shareCollection', postData);
		return data;
	} catch (error) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const deleterCollection = async (postData) => {
	try {
		const { data } = await ApiClient.POST('deleteCollection', postData);
		return data;
	} catch (error) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchPresentationDefaultCoverImages = async () => {
	try {
		const { data } = await ApiClient.GET('fetchPresentationDefaultImages');
		return data;
	} catch (error) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const removePresentationSequenceDoc = async (postData) => {
	try {
		const { data } = await ApiClient.POST('removePresentationSequenceDoc', postData);
		return data;
	} catch (error) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const addPresentationSequence = async (postData, presentationId) => {
	try {
		const { data } = await ApiClient.POST('addPresentationSequence', postData, `/${presentationId}`);
		return data;
	} catch (error) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const approvedCollection = async (collectionId) => {
	try {
		const { data } = await ApiClient.POST(
			`${BASE_URL}/collection/${collectionId}/approved`,
			{},
			'',
			true
		);
		return data;
	} catch (error) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const getPresentationSequence = async (presentationId) => {
	try {
		const { data } = await ApiClient.GET('getPresentationSequence', presentationId);
		return data;
	} catch (error) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const getPresentationSequenceEmailContent = async (entityId, entityType) => {
	try {
		const query = `${entityId}?entityType=${entityType}`;
		const { data } = await ApiClient.GET('getPresentationSequenceEmailContent', query);
		return data;
	} catch (error) {
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const createSetOrder = async (type, params) => {
	try {
		const { data } = await ApiClient.POST(`${BASE_URL}/product/${type}`, '', params, true);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const updateSetOrder = async (type, id, params) => {
	try {
		const { data } = await ApiClient.PUT(`${BASE_URL}/product/${type}/${id}`, '', params, true);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const deleteSetOrder = async (type, id) => {
	try {
		const { data } = await ApiClient.DELETE(`${BASE_URL}/product/${type}/${id}`, '', '', true);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getSetProducts = async (id) => {
	try {
		const { data } = await ApiClient.GET(`${BASE_URL}/product/set/${id}/products`, '', true);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getSetInfo = async (id) => {
	try {
		const { data } = await ApiClient.GET(`${BASE_URL}/product/set-info/${id}`, '', true);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const doCollectionWiseDraftByProductId = async (collectionId, requestBody) => {
	try {
		const { data } = await ApiClient.POST(
			`${BASE_URL}/collection/${collectionId}/draft`,
			requestBody,
			'',
			true
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const doCollectionWiseUnDraftByProductId = async (collectionId, productId) => {
	try {
		const { data } = await ApiClient.POST(
			`${BASE_URL}/collection/${collectionId}/undraft/${productId}`,
			'',
			'',
			true
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const createNewTag = async (productId, requestBody, params = '') => {
	try {
		const { data } = await ApiClient.POST(
			`${BASE_URL}/product/${productId}/tags/add`,
			requestBody,
			params,
			true
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const createTagForSelectedProducts = async (requestBody) => {
	try {
		const { data } = await ApiClient.POST(`${BASE_URL}/product/tags/add`, requestBody, '', true);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchAllProductTags = async (params, cancelToken) => {
	const updateParams = params;
	try {
		const { data } = await ApiClient.GET('productWiseTags', updateParams, false, { cancelToken });
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const removeProductTagId = async (productId, tagId) => {
	try {
		const { data } = await ApiClient.DELETE(
			`${BASE_URL}/product/${productId}/tags/${tagId}`,
			'',
			'',
			true
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const removeProductTagIds = async (params, tagId) => {
	try {
		const { data } = await ApiClient.DELETE(`${BASE_URL}/product/tags/${tagId}`, '', params, true);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchProductStatusByStage = async (params) => {
	try {
		const { data } = await ApiClient.GET('productStatus', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchProductFilterOptions = async (params, body) => {
	try {
		const data = await ApiClient.POST('getCollectionProducts', body, params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const saveProductRemarks = async (productId, params) => {
	try {
		const { data } = await ApiClient.POST(
			`${BASE_URL}/product/collection-remarks/${productId}`,
			'',
			params,
			true
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getCollectionDetailsCount = async (collectionId, params) => {
	try {
		const query = params + `&collectionId=${collectionId}`;
		const { data } = await ApiClient.GET(
			`${BASE_URL}/collection/${collectionId}/product/stage-count`,
			query,
			true
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getCollectionDetailsTagsCount = async (collectionId, params) => {
	try {
		const query = params + `&collectionId=${collectionId}`;
		const { data } = await ApiClient.GET(`${BASE_URL}/collection/${collectionId}/tag-count`, query, true);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const createNewStyle = async (requestBody) => {
	try {
		const { data } = await ApiClient.POST('createAsNewStyle', requestBody);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchCollectionPurpose = async () => {
	try {
		const params = '?type=COLLECTION_CREATION_PURPOSE&size=1000';
		const { data } = await ApiClient.GET('getAllTags', params);
		const collectionPurposeList = data.map((item) => ({
			...item,
			value: item?.text
		}));
		return collectionPurposeList;
	} catch (error) {
		printApiError(error);
	}
};

export const getDesignPublishStatus = async (productIds) => {
	try {
		const params = `?ids=${productIds}`;
		const { data } = await ApiClient.GET('designPublishStatus', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const submitPublishDesign = async (productId) => {
	try {
		const param = `publish?ids=${productId}`;
		const { data } = await ApiClient.POST('publishDesign', {}, `${param}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getProductDetailsFilterFields = (requestBody) => async (dispatch) => {
	try {
		const { data } = await ApiClient.POST('getFolderDetailsFilterFields', requestBody);
		dispatch({
			type: Types.STORE_DEPENDENT_FILTER_LIST,
			payload: { responseData: data, filterListPage: 'FAVOURITE_DETAILS' }
		});
	} catch (error) {
		printApiError(error);
	}
};

export const getCollectionDetailsFilterFields = (collectionId, requestBody) => async (dispatch) => {
	try {
		const path = `${collectionId}/filter-options`;
		const { data } = await ApiClient.POST('getCollectionProducts', requestBody, path);
		dispatch({
			type: Types.STORE_DEPENDENT_FILTER_LIST,
			payload: { responseData: data, filterListPage: 'COLLECTION_DETAILS' }
		});
	} catch (error) {
		printApiError(error);
	}
};
